(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["roadnest-accessory"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-roadnest-accessory]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.rn-accessory__form');
    const button = root.querySelector('[data-rn-accessory-add]');
    const status = root.querySelector('[data-rn-accessory-status]');
    const cartLink = root.querySelector('[data-rn-accessory-cart]');
    const messages = root.querySelector('.rn-accessory__messages').dataset;
    const initialLabel = button.textContent;
    let pending = false;
    const openDrawer = () => {
      const drawer = document.querySelector('theme-drawer cart-drawer-component')?.closest('theme-drawer');
      if (drawer?.open) drawer.open();
      else window.location.assign(root.dataset.cartUrl);
    };
    root.querySelector('[data-rn-open-cart]')?.addEventListener('click', openDrawer);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (pending || button.disabled) return;
      pending = true;
      button.disabled = true;
      button.textContent = messages.adding;
      status.hidden = true;
      let committed = false;
      let renderFailed = false;
      try {
        const data = new FormData(form);
        const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((node) => node.dataset.sectionId).filter(Boolean);
        if (sectionIds.length) data.set('sections', [...new Set(sectionIds)].join(','));
        const response = await fetch(root.dataset.cartAddUrl, {method:'POST',headers:{Accept:'application/json'},body:data});
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || messages.error);
        }
        committed = true;
        const added = await response.json();
        const cartResponse = await fetch(`${root.dataset.cartUrl}.js`,{headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(messages.error);
        const cart = await cartResponse.json();
        root.querySelectorAll('[data-rn-cart-count]').forEach((node) => node.textContent = cart.item_count);
        const update = new CustomEvent('shopify:cart:lines-update',{bubbles:true});
        Object.defineProperties(update,{action:{value:'add'},promise:{value:Promise.resolve({cart:{...cart,totalQuantity:cart.item_count},detail:{items:cart.items,itemCount:1,sections:added.sections || {},didError:false}})}});
        document.dispatchEvent(update);
        status.textContent = messages.added;
        cartLink.hidden = false;
        requestAnimationFrame(openDrawer);
      } catch (error) {
        renderFailed = true;
        status.textContent = committed ? messages.added : (error.message || messages.error);
        cartLink.hidden = false;
      } finally {
        status.hidden = false;
        pending = false;
        button.textContent = initialLabel;
        button.disabled = root.dataset.available !== 'true' || renderFailed;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
